const getFrotaFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'frota', label: 'Nº da Frota', initial: true },
  { name: 'descricao', label: 'Descrição' },
  { name: 'placa', label: 'Placa' },
  { name: 'marca', label: 'Marca' },
  { name: 'modelo', label: 'Modelo' },
  { name: 'anofab', label: 'Ano de Fabricação', type: 'number' },
  { name: 'anoveic', label: 'Ano do Veículo', type: 'number' },
];

export default getFrotaFilterFields;
